/* External */
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/* Storage */
import { selectCarouselsListByCarouselInfoList } from '../storage/carousels';

export default function usePageCarousels(page, filtered = false) {
  const selector = useMemo(
    () => selectCarouselsListByCarouselInfoList(page?.carousels || page?.elements, filtered),
    [page?.carousels, page?.elements, filtered],
  );
  return useSelector(selector);
}
